import { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { AppRoutes } from "./router";
import i18n from "./i18n";
import { ModeProvider } from "@/context/ModeContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { CompareProvider } from "@/context/CompareContext";
import { WatchLaterProvider } from "@/context/WatchLaterContext";
import { SavedSearchesProvider } from "@/context/SavedSearchesContext";
import ScrollToTop from "@/components/feature/ScrollToTop";

/**
 * 開発環境専用の通信失敗シミュレーター。
 * import.meta.env.DEV が false の本番ビルドでは、この分岐ごと削除されるため
 * パネルのコードはバンドルに含まれない。
 */
const DevFailurePanel = import.meta.env.DEV
  ? lazy(() => import("@/components/feature/DevFailurePanel"))
  : null;

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ModeProvider>
          <FavoritesProvider>
            <CompareProvider>
              <WatchLaterProvider>
                <SavedSearchesProvider>
                  <ScrollToTop />
                  <AppRoutes />
                  {DevFailurePanel ? (
                    <Suspense fallback={null}>
                      <DevFailurePanel />
                    </Suspense>
                  ) : null}
                </SavedSearchesProvider>
              </WatchLaterProvider>
            </CompareProvider>
          </FavoritesProvider>
        </ModeProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;